import Link from 'next/link'
import React from 'react'

import { Text } from '@wartek-id/text'
import { Avatar } from '@wartek-id/avatar'

import { GATrackEvent } from 'utils/googleAnalytics'

interface AksiNyataItemProps {
  href: string
  title: string
  topicName: string
  email: string
  topicId: string
  avatarUrl?: string
  author: string
  school?: string
  order: number
  aksiNyataId: string
}

const AksiNyataListItem = ({
  href,
  title,
  email,
  avatarUrl = undefined,
  author,
  school,
  topicName,
  aksiNyataId,
  order,
}: AksiNyataItemProps) => {
  const trackClick = () => {
    GATrackEvent({
      eventName: 'learning_activity',
      eventParams: {
        event_trigger: 'aksinyata_list_page',
        action_type: 'click_aksinyata_from_list',
        meta: JSON.stringify({
          aksi_nyata_id: aksiNyataId,
          order: order,
        }),
      },
      sendDefaultParams: true,
    })
  }

  return (
    <div className="relative py-3 px-4 border-b border-subdued last:border-b-0">
      <Link href={href} passHref>
        <Text onClick={trackClick} className="mb-1 overlay-link" as="a">
          <span className="text-[17px]">{title}</span>
        </Text>
      </Link>
      <Text className="mb-2" variant="helper" color="subdued">
        <strong>{topicName}</strong>
      </Text>
      <div className="flex items-center">
        <div className="mr-2">
          <Avatar
            src={avatarUrl}
            alt={author}
            name={!!author && author.length > 0 ? author : 'guru'}
            size="md"
          />
        </div>
        <div>
          <Text variant="body-sm">
            {!!author && author.length > 0 ? author : email}
          </Text>
          {!!school && (
            <Text variant="helper" color="subdued">
              {school}
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}

export default AksiNyataListItem
